import { Box, Grid } from "@material-ui/core";
import React, { Fragment } from "react";
import OnboardingSideMenu from "../../../modules/workspaces/components/create/OnboardingSideMenu/OnboardingSideMenu";
import { ContentLayout } from "../../../layouts/content/content.layout";
import { useCreateWorkspaceWizard } from "../../../modules/workspaces/hooks/useCreateWorkspaceWizard";

import WizardFooter from "../../../modules/workspaces/components/wizard/wizard-footer/wizard-footer.component";
import { MenuTabItem } from "../../../modules/workspaces/types/create-workspace-wizard";

const WorkSpaceWizardPage = () => {
  const {
    activeStep,
    totalSteps,
    tabConfig,
    submitting,
    currentData,
    isCurrentStepValid,
    stepValidationErrors,
    handleStepChange,
    handleNext,
    handlePrev,
    handleSubmit,
    StepComponent,
  } = useCreateWorkspaceWizard();

  const menuTabs: MenuTabItem[] = tabConfig.map((tab: any) => ({
    label: tab.label,
    component: <Fragment />,
  }));

  return (
    <Box height={"100vh"} overflow={"hidden"} bgcolor="#ffffff">
      <Box height={"100%"} display="flex">
        <Box width={"480px"}>
          <OnboardingSideMenu
            menuTabs={menuTabs as any}
            selectedTab={activeStep}
          />
        </Box>
        <Box width={"calc(100% - 480px)"}>
          <ContentLayout>
            <Grid
              className="contentPane"
              container
              justify="center"
              style={{ overflowY: "scroll", height: "100%" }}
            >
              <Grid item xs={11}>
                <Box mt={5} mb={5}>
                  <StepComponent
                    data={currentData}
                    onChange={handleStepChange}
                    errors={stepValidationErrors}
                  />
                  <WizardFooter
                    activeStep={activeStep}
                    totalSteps={totalSteps}
                    onPrev={handlePrev}
                    onNext={handleNext}
                    onSubmit={handleSubmit}
                    isNextDisabled={!isCurrentStepValid}
                    isSubmitDisabled={!isCurrentStepValid}
                    submitting={submitting}
                  />
                </Box>
              </Grid>
            </Grid>
          </ContentLayout>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkSpaceWizardPage;
